<template>
  <div class="input-group bootstrap-timepicker">
    <input type="text" class="form-control" :value="durationTimeFormat" ref="input" @change="onChange">
    <span class="input-group-addon" v-if="showIcon"><i class="pg-clock"></i></span>
  </div>
</template>

<script>
import { TimeFormatRegex } from '@/settings/regex'
import { convertDurationTimeToMinutes, convertMinutesToDurationTime } from '@/helpers/timeCodes'

export default {
  name: 'duration-time-input',
  props: ['value', 'showIcon'],
  data: function(){
    return {
      shouldBeEmitted: true,
      currentValue: 0
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      this.shouldBeEmitted = false
      $(this.$refs.input).timepicker("setTime", this.durationTimeFormat);
    }
  },
  computed: {
    durationTimeFormat() {
      if (!this.value) return ''
      return convertMinutesToDurationTime(this.value)
    }
  },
  methods: {
    updateValue(){
      if(this.shouldBeEmitted){
        let convertedValue = this.convertToMinutes(this.$refs.input.value)
        if (convertedValue != this.currentValue) {
          this.currentValue = convertedValue
          this.$emit('input', this.currentValue)
        }
      } else {
        this.shouldBeEmitted = true
      }
    },
    convertToMinutes(durationTime){
      if (!TimeFormatRegex.test(durationTime)) { return durationTime }
      return convertDurationTimeToMinutes(durationTime)
    },
    onChange(){
      if (this.$refs.input.value == ''){
        // timepicker doesn't handle for empty input
        this.$emit('input', '')
      } else {
        this.updateValue()
      }
    }
  },
  mounted: function(){
    $(this.$refs.input).timepicker({
      minuteStep: 15,
      showMeridian: false,
      defaultTime: '',
      icons: {
        up: 'pg-arrow_maximize',
        down: 'pg-arrow_minimize'
      },
    })
    .on("changeTime.timepicker", (event) => {
      this.updateValue()
    });
  }
}
</script>

<style>
  .bootstrap-timepicker-hour,
  .bootstrap-timepicker-minute {
    border: 1px solid rgba(0, 0, 0, 0.07) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/timeCodes/DurationTimeInput.vue